namespace RedBullMOBILE360.PushNotifications {
    export class PushNotificationsColumns {
        static columnsKey = 'PushNotifications.PushNotifications';
    }
}